import { useJobs } from '@/hooks/useJobs';
import { useEffect } from 'react';

/**
 * Component to dynamically generate sitemap entries for job postings
 * This helps search engines discover all job pages
 */
export const JobSitemap = () => {
  const { allJobs } = useJobs();

  useEffect(() => {
    if (allJobs.length > 0) {
      // Generate sitemap entries for each job
      const sitemapEntries = allJobs.map(job => ({
        url: `${window.location.origin}/stellenangebote/${job.id}`,
        lastmod: job.publishDate,
        changefreq: 'weekly',
        priority: '0.8'
      }));

      // Store in global window object for potential sitemap generation
      (window as any).__jobSitemap = sitemapEntries;
      
      console.log(`Generated sitemap entries for ${sitemapEntries.length} jobs`);
    }
  }, [allJobs]);

  return null;
};